/* lm-zine — fixed-viewport publication reader, one StPageFlip book for every size.
   usePortrait shows a 2-page open book on desktop/tablet and a single page on mobile, both flipping. The
   prev/next arrows + click/drag turn pages; the counter tracks the current page. The footer height is
   measured into --lm-footer-h so the pinned footer never crowds the reader. */
(function () {
  'use strict';
  document.documentElement.classList.add('lm-zine-page');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var book = document.querySelector('[data-lm-zine-book]');
    var nowEl = document.querySelector('[data-lm-zine-now]');
    var totalEl = document.querySelector('[data-lm-zine-total]');
    var prevBtn = document.querySelector('[data-lm-zine-prev]');
    var nextBtn = document.querySelector('[data-lm-zine-next]');
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var flip = null;

    function measureFooter() {
      var f = document.querySelector('.footer') || document.querySelector('footer');
      if (f) { document.documentElement.style.setProperty('--lm-footer-h', Math.round(f.getBoundingClientRect().height) + 'px'); }
    }

    function updateCounter() {
      if (!flip) { return; }
      try {
        var idx = flip.getCurrentPageIndex();
        var total = flip.getPageCount();
        if (nowEl) { nowEl.textContent = pad(idx + 1); }
        if (totalEl) { totalEl.textContent = pad(total); }
      } catch (e) {}
    }

    function initBook() {
      if (flip || !book || !window.St || !window.St.PageFlip) { return; }
      if (book.clientWidth < 80 || book.clientHeight < 80) { return; }
      try {
        flip = new window.St.PageFlip(book, {
          width: 380, height: 520,
          size: 'stretch',
          minWidth: 200, maxWidth: 1100,
          minHeight: 280, maxHeight: 1500,
          showCover: true,
          usePortrait: true,
          mobileScrollSupport: false,
          drawShadow: true,
          maxShadowOpacity: 0.2,
          flippingTime: 600,
          swipeDistance: 28
        });
        flip.loadFromHTML(book.querySelectorAll('.lm-zine__page'));
        flip.on('flip', updateCounter);
        flip.on('changeOrientation', updateCounter);
        updateCounter();
      } catch (e) { flip = null; }
    }

    if (prevBtn) { prevBtn.addEventListener('click', function () { if (flip) { flip.flipPrev(); } }); }
    if (nextBtn) { nextBtn.addEventListener('click', function () { if (flip) { flip.flipNext(); } }); }

    window.addEventListener('resize', measureFooter, { passive: true });
    window.addEventListener('load', function () { measureFooter(); initBook(); });

    measureFooter();
    requestAnimationFrame(function () { requestAnimationFrame(initBook); });
  });
})();
